<template>
  <div class="warehouse_selector_container">
    <DxDataGrid
      :element-attr="gridAttributes"
      ref="warehouseGrid"
      class="warehouse_grid"
      :data-source="warehouses"
      :show-column-headers="false"
      :hover-state-enabled="true"
      :remote-operations="false"
      :repaint-changes-only="true"
      :selected-row-keys="selectedWarehouses"
      @selection-changed="onSelectionChanged"
      @row-click="onRowClick"
      height="100%"
    >
      <DxSelection mode="multiple" showCheckBoxesMode="always" />
      <DxFilterRow :visible="true" />
      <DxPaging :enabled="true" />
      <DxScrolling mode="infinite" />
      <DxColumn dataField="name" caption="Denumire" :filter-operations="['contains']"/>
      <DxColumn dataField="department.name" caption="Departamente" :filter-operations="['contains']"/>
    </DxDataGrid>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { DxDataGrid, DxColumn, DxSelection, DxFilterRow, DxScrolling, DxPaging } from "devextreme-vue/data-grid";
import { BButton } from "bootstrap-vue";

export default {
  name: "WareHouseSelector",
  props: {
    selectedWarehouses: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxSelection,
    DxFilterRow,
    DxScrolling,
    DxPaging,
    BButton,
  },
  data() {
    return {
      gridAttributes: {
        class: "grid_general_mobile_style",
      },
    };
  },
  computed: {
    ...mapGetters({
      warehouses: "smWarehouses/smWarehouses",
    }),
  },
  methods: {
    ...mapActions({
      getWarehouses: "smWarehouses/getSmWarehouses",
    }),
    onSelectionChanged(e) {
      this.$emit("update:selectedWarehouses", e.selectedRowKeys);
    },
    onRowClick(e) {
      const rowKey = e.key; // Get the unique key of the clicked row
      const selectedIndex = this.selectedWarehouses.indexOf(rowKey);

      if (selectedIndex === -1) {
        // If the row is not selected, add it to the selection
        this.selectedWarehouses.push(rowKey);
      } else {
        // If the row is already selected, remove it from the selection
        this.selectedWarehouses.splice(selectedIndex, 1);
      }

      // Update the grid's selected rows
      this.$refs.warehouseGrid.instance.selectRows(this.selectedWarehouses, false);
    },
  },
  mounted() {
    if (this.warehouses.length === 0) {
      this.getWarehouses({
          enablePagination: 0,
          limit: 1000,
          filter: [["is_active", "=", 1]],
        })
        .then((response) => {
          console.log("Warehouses fetched successfully");
        })
        .catch((error) => {
          console.error("Error fetching warehouses:", error);
        });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/dxMobileGridGeneral.scss";

.warehouse_selector_container {
  width: 100%;
  height: 100%;
  padding: 0 5px 0 5px;
}

.warehouse_grid {
  height: calc(100% - 60px);
}
</style>
